import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Container } from "../../ui";

export const NoCalendarFeedItemMessage = inject("store")(
  observer(() => {
    const { t } = useTranslation();
    return (
      <Container>
        <p>{t("no_events")}</p>
      </Container>
    );
  }),
);
